<div class="toolbar">
    <div class="back-flex-container">
        <button type="button" class="btn" [routerLink]="['/']">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <span class="fw-bold">بازگشت</span>
    </div>
    <input type="search" class="form-control" [(ngModel)]="searchKey" placeholder="جستجو..." autofocus>
</div>

<div class="table-responsive" *ngIf="(myRegistrations$ | async) as myRegistrations">
    <table class="app-table">
        <thead>
            <tr>
                <th class="fw-bold">ردیف</th>
                <th class="fw-bold">تاریخ ثبت نام</th>
                <th class="fw-bold">نام و نام خانوادگی</th>
                <th class="fw-bold">موبایل</th>
                <th class="fw-bold">وضعیت</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="myRegistrations | filter : searchKey : ['strName', 'strFamily', 'strMobile'] as myRegistrationsFiltered">
                <ng-container *ngIf="myRegistrationsFiltered.length;else elseTemplate">
                    <tr *ngFor="let myRegistration of myRegistrationsFiltered; let index = index" (click)="openDtailsDialog(myRegistration)">
                        <td>{{index + 1}}</td>
                        <td>{{myRegistration.strRegisterDateTime}}</td>
                        <td>{{myRegistration.strName}} {{myRegistration.strFamily}}</td>
                        <td>{{myRegistration.strMobile}}</td>
                        <td>{{myRegistration.strInstallationStatus}}</td>
                    </tr>
                </ng-container>

                <ng-template #elseTemplate>
                    <tr>
                        <td colspan="6">موردی یافت نشد.</td>
                    </tr>
                </ng-template>
            </ng-container>
        </tbody>
    </table>
</div>

<!-- Dtails Dialog -->
<ng-template #detailsDialogTemplate let-modal>
    <ng-container>
        <div class="modal-header">
            <h2 class="modal-title">نمایش اطلاعات تانکر</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
        </div>
        <div class="modal-body">
            <div class="grid-container">
                <div class="field-wrapper">
                    <label for="name-field">نام</label>
                    <input type="text" class="form-control" readonly id="name-field" [value]="tankerProfile.strName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="family-field">نام خانوادگی</label>
                    <input type="text" class="form-control" readonly id="family-field" [value]="tankerProfile.strFamily || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="national-id-field">کد ملی مالک تانکر</label>
                    <input type="text" class="form-control direction-ltr" readonly id="national-id-field" [value]="tankerProfile.strID || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="date-field">تاریخ ثبت</label>
                    <input type="text" class="form-control direction-ltr" readonly id="date-field" [value]="tankerProfile.strRegisterDateTime || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="vehicle-type-field">نوع خودرو</label>
                    <input type="text" class="form-control" readonly id="vehicle-type-field" [value]="tankerProfile.strGPSType_strComment || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="vehicle-no-field">پلاک</label>
                    <input type="text" class="form-control" readonly id="vehicle-no-field" [value]="tankerProfile.strVehicleNo || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="city-field">شهر</label>
                    <input type="text" class="form-control" readonly id="city-field" [value]="tankerProfile.strCityName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="state-field">آدرس</label>
                    <input type="text" class="form-control" readonly id="state-field" [value]="tankerProfile.strAddress || '-'">
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>